import { useNavigation } from '@react-navigation/native'
import React from 'react'
import { StyleSheet } from 'react-native'

import { Avatar } from 'widgets/Avatar'
import { Box } from 'widgets/Box'
import { Pressable } from 'widgets/Pressable'
import { Text } from 'widgets/Text'
import { UpspaceRowMembers } from 'widgets/UpspaceRowMembers'

import { useCurrentUser } from 'hooks/useCurrentUser'
import { useGroup } from 'hooks/useGroup'
import { useUpspaceRoom } from 'hooks/useUpspaceRoom'
import { useUser } from 'hooks/useUser'

import { links } from 'utils/constants'

import { Subscription } from 'types/subscription'

type Props = {
  subscription: Subscription
}

const styles = StyleSheet.create({
  innerUpspaceChatRoomContainer: {
    borderRadius: 36,
  },
  unreadIndicator: {
    position: 'absolute',
    zIndex: 99,
    top: 0,
    left: 48,
  },
})

export const UpspaceChatRow = ({ subscription }: Props) => {
  const navigation = useNavigation<any>()
  const { data: currentUser } = useCurrentUser()
  const currentUserId = currentUser?.id
  const { data: room } = useUpspaceRoom({ program: subscription.program, userId: currentUserId })
  const { data: subscriptionGroup } = useGroup({ groupId: subscription?.program?.id })
  const { data: groupTrainer } = useUser({ userId: subscriptionGroup?.id })

  const hasUnreadMsgs: boolean =
    room?.meta !== undefined &&
    room?.meta?.newMessageCount !== undefined &&
    room?.meta?.newMessageCount > 0

  return (
    <Pressable
      onPress={() => navigation.navigate(links.CHAT_ROOM, { roomId: room?.id, subscription })}
    >
      <Box flexDirection='row'>
        <Box
          flex={1}
          flexDirection='row'
          align='center'
          margin={{ horizontal: 'md', vertical: 'sm' }}
          border={{ width: 1, color: hasUnreadMsgs ? 'v2primary' : 'grey' }}
          testID='InnerUpspaceChatRowContainer'
          style={styles.innerUpspaceChatRoomContainer}
        >
          <Box flex={1} flexDirection='row' align='center' margin='xxs'>
            <Avatar width={64} height={64} image={groupTrainer?.avatar} />
            {hasUnreadMsgs && (
              <Box
                backgroundColor='v2primary'
                borderRadius='xl'
                align='center'
                width={20}
                height={20}
                style={styles.unreadIndicator}
              >
                <Text fontSize='sm'>
                  {room?.meta?.newMessageCount && room?.meta?.newMessageCount >= 10
                    ? '9+'
                    : room?.meta?.newMessageCount}
                </Text>
              </Box>
            )}
            <Box margin={{ left: 'smd', right: 'xs' }} flex={1}>
              <Text numberOfLines={2} bold fontSize='sm'>
                {currentUser?.id === groupTrainer?.id && `My Group`}
                {currentUser?.id !== groupTrainer?.id &&
                  `${groupTrainer?.firstName} ${groupTrainer?.lastName}'s Group`}
              </Text>
            </Box>
          </Box>

          <UpspaceRowMembers subscription={subscription} itemSize={32} />
        </Box>
      </Box>
    </Pressable>
  )
}
